import jQuery from 'jquery';
import jqueryMatchHeight from 'jquery-match-height';

export default function matchHeight(elementsSelector) {
  let $elements = jQuery(elementsSelector);
  // Wait for images in children to load before attempting to match height.
  let $images = $elements.find('img').filter(function() {
    return !this.complete;
  });
  let numUnloaded = $images.length;
  let match = () => {
    $elements.matchHeight();
  };

  if (numUnloaded > 0) {
    $images.on('load', () => {
      if (--numUnloaded == 0) {
        match();
      }
    });
  }
  else {
    match();
  }
};



// WEBPACK FOOTER //
// ./app/lib/match-height-after-img-load.js